// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from SwiperCarouselContainer.module.scss  */
.SwiperCarouselContainer-module-Root_2S5 {
  position: relative;
  display: flex;
  width: 100%; }

.SwiperCarouselContainer-module-Slide_VNK {
  flex-shrink: 0;
  width: auto; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/SwiperCarousel/SwiperCarouselContainer/SwiperCarouselContainer.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,WAAW,EAAE","sourcesContent":["/*  imported from SwiperCarouselContainer.module.scss  */\n.SwiperCarouselContainer-module-Root_2S5 {\n  position: relative;\n  display: flex;\n  width: 100%; }\n\n.SwiperCarouselContainer-module-Slide_VNK {\n  flex-shrink: 0;\n  width: auto; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
